import {
    USER_INFO,
    USER_INFO_LOAD,
    USER_INFO_ERROR,
    USERS_LOAD,
    USERS_SUCCESS,
    USERS_ERROR,
    USER_COMPLETE_ERROR,
    USER_COMPLETE_LOAD,
    USER_COMPLETE_SUCCESS,
    USER_ACCESS_LOAD,
    USER_ACCESS_ERROR,
    USER_ACCESS_SUCCESS
} from '../actionTypes'

const initialState = {
    userLogged: {},
    isLoading: true,
    users: [],
    carteira: [],
    completeLoading: false,
    message: null,
    success: false,
    isLoadingAccess: false,
}

export default (state = initialState, action) => {
    switch(action.type) {
        case USER_ACCESS_ERROR:
            return{
                ...state,
                message: action.payload.message,
                success: false,
                isLoadingAccess: false
            }
        case USER_ACCESS_LOAD:
            return{
                ...state,
                isLoadingAccess: true
            }
        case USER_ACCESS_SUCCESS:
            return{
                ...state,
                isLoadingAccess: false,
                success: true,
                message: action.payload.message
            }
        case USER_COMPLETE_ERROR:
            return{
                ...state,
                message: action.payload.message,
                completeLoading: false,
                success: false
            }
        case USER_COMPLETE_LOAD:
            return{
                ...state,
                completeLoading: true,
            }
        case USER_COMPLETE_SUCCESS:
            return{
                ...state,
                completeLoading: false,
                success: true,
                message: null
            }
        case USER_INFO:
            return {
                ...state,
                userLogged: action.payload.user,
                isLoading: false
            }
        
        case USER_INFO_LOAD:
            return {
                ...state,
                userLogged: {},
                isLoading: true
            }

        case USER_INFO_ERROR:
            return {
                ...state,
                userLogged: {},
                isLoading: false
            }

        case USERS_LOAD:
            return {
                ...state,
                isLoading: true
            }

        case USERS_SUCCESS:
            // console.log(action.payload.users)
            return {
                ...state,
                isLoading: false,
                users: action.payload.users
            }

        case USERS_ERROR:
            return {
                ...state,
                isLoading: false,
            }

        default:
            return state
    }
}